// Get auth token from session storage
export const getAuthToken = () => {
  return sessionStorage.getItem('token');
}; 